export default __webpack_public_path__ + "static/media/Linuxpinguin.546a3233.png";